module.exports = __webpack_public_path__ + "media/konosuba.d4291fe9.mp3";